import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Button } from "reactstrap";
import CustomForm from "../../../custom/Forms/CustomForm.js";
import SelectInput from "../../../custom/components/Select-Input/SelectInput.js";
import TextInput from "../../../custom/components/Text-Input/TextInput.js";
import TextAreaInput from "../../../custom/components/TextArea-Input/TextAreaInput.js";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, basicFormData } from "./ItemFile.js";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput.js";
import Asterisks from "../../../custom/components/Asterisks/Asterisks.js";
import { validate } from "../../../custom/validations/Validate.js";
import { getRecords, saveRecords } from "../../../services/api.service.js";
import { toast } from "react-toastify";
import { LoaderCreatePage } from "../../Loader/Loader.js";
import { loaderOverlay } from "../../../Style/loaderOverly.js";
import NumberInput from "../../../custom/components/Number-Input/NumberInput.js";

const ItemCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  } = createPageData();

  const schema = localStorage.getItem("schema");
  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [formErrors, setFormErrors] = useState({});
  // role
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categorySelectOptions, setCategorySelectOptions] = useState([]);

  const [selectedUom, setSelectedUom] = useState(null);
  const [uomSelectOptions, setUomSelectOptions] = useState([]);

  const [selectedGroup, setSelectedGroup] = useState(null);
  const [groupSelectOptions, setGroupSelectOptions] = useState([]);

  const [selectedOEM, setSelectedOEM] = useState(null);
  const [OEMSelectOptions, setOEMSelectOptions] = useState([]);

  const [itemNameError, setItemNameError] = useState(null);
  const [itemCodeError, setItemCodeError] = useState(null);

  const [showOemAndGroup, setShowOemAndGroup] = useState(false);

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  useEffect(() => {
    getCategoryData();
    getUomData();
    getOEMData();
    getGroupData();
  }, []);

  const getEditData = async (id) => {
    setLoadingData(true);
    try {
      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
        include: initialPayload?.include,
      };

      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        setFormData({ inputData: data });
        setSelectedCategory({
          value: data?.category_id,
          label: data?.category?.name,
          type: data?.category?.type,
        });
        setSelectedUom({ value: data?.uom_id, label: data?.uom?.name });
        setSelectedOEM({ value: data?.oem_id, label: data?.oem?.name });
        setSelectedGroup({ value: data?.group_id, label: data?.group?.name });
        if (data?.category?.type === 0) {
          setShowOemAndGroup(true);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const getCategoryData = async () => {
    setLoadingData(true);
    try {
      let payload = {
        modelName: "category_masters",
        whereCondition: {
          is_active: true,
        },
        schema: schema,
        orderBy: {
          field: "name",
          order: "asc",
        },
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map((item) => ({
        value: item.id,
        label: item.name,
        type: item.type,
      }));
      setCategorySelectOptions(newArray);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false);
  };

  const getUomData = async () => {
    setLoadingData(true);
    try {
      let payload = {
        modelName: "uom_masters",
        whereCondition: {
          is_active: true,
        },
        schema: schema,
        orderBy: {
          field: "name",
          order: "asc",
        },
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setUomSelectOptions(newArray);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false);
  };
  const getOEMData = async () => {
    setLoadingData(true);
    try {
      let payload = {
        modelName: "oem_master",
        whereCondition: {
          is_active: true,
        },
        schema: schema,
        orderBy: {
          field: "name",
          order: "asc",
        },
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setOEMSelectOptions(newArray);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false);
  };
  const getGroupData = async () => {
    setLoadingData(true);
    try {
      let payload = {
        modelName: "group_master",
        whereCondition: {
          is_active: true,
        },
        schema: schema,
        orderBy: {
          field: "name",
          order: "asc",
        },
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setGroupSelectOptions(newArray);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false);
  };

  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormErrors((prevErrors) => {
      const fieldError = validate(validationType, { [name]: value });
      return {
        ...prevErrors,
        [name]: fieldError[name] || null,
      };
    });

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]:
          type === "checkbox"
            ? checked === true
              ? 1
              : 0
            : name === "alt_mobile_number" && value === ""
            ? null
            : value,
      },
    }));
  };

  const handleCategorySelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      category_id: selectedValue,
    });

    setSelectedCategory(options);

    if (options?.type === 0) {
      setShowOemAndGroup(true);
    } else {
      setShowOemAndGroup(false);
    }

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      category_id: fieldError?.category_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        category_id: selectedValue,
      },
    }));
  };

  const handleUomSelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      uom_id: selectedValue,
    });

    setSelectedUom(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      uom_id: fieldError?.uom_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        uom_id: selectedValue,
      },
    }));
  };
  const handleOEMSelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      oem_id: selectedValue,
    });

    setSelectedOEM(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      oem_id: fieldError?.oem_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        oem_id: selectedValue,
      },
    }));
  };
  const handleGroupSelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      group_id: selectedValue,
    });

    setSelectedGroup(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      group_id: fieldError?.group_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        group_id: selectedValue,
      },
    }));
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingData(true);

      const userDetails = JSON.parse(localStorage.getItem("authUser"));
      const validationErrors = validate(validationType, formData.inputData);
      if (!showOemAndGroup) {
        delete validationErrors["group_id"];
        delete validationErrors["oem_id"];
      }
      // console.log("validationErrors", validationErrors);
      setFormErrors(validationErrors);
      if (JSON.stringify(validationErrors) !== "{}") return;
      // Additional validation for `user_documents`

      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
      };

      if (id) {
        // update
        formData.inputData.updated_by = id ? userDetails?.id || "" : "";
        payload = { ...payload, id: id, inputData: formData.inputData };
      } else {
        // create
        formData.inputData.created_by = userDetails?.id || "";
        formData.inputData.updated_by = userDetails?.id || "";
        payload = { ...payload, inputData: formData.inputData };
      }
      if (!showOemAndGroup) {
        payload = {
          ...payload,
          inputData: {
            ...payload?.inputData,
            oem_id: null,
            group_id: null,
          },
        };
      }
      // console.log(payload);
      // return;
      const responseData = id
        ? await saveRecords(payload, updateEndpoint)
        : await saveRecords(payload, createEndpoint);

      // Handle response
      if (responseData && responseData.code === 1) {
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData.message || `Error while saving ${headerName}!`
        );
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };

  // add document

  useEffect(() => {
    if (formErrors?.name) {
      const updatedError = formErrors.name.replace(/\bName\b/, "Item name");

      setItemNameError(updatedError);
    } else setItemNameError(null);
  }, [formErrors?.name]);

  useEffect(() => {
    if (formErrors?.code) {
      const updatedError = formErrors.code.replace(/\bCode\b/, "Item code");

      setItemCodeError(updatedError);
    } else setItemCodeError(null);
  }, [formErrors?.code]);

  return (
    <CustomForm
      title={id ? "UPDATE " + headerName : "CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <Row className="mt-2">
        <Col md="6" className="mt-3">
          <TextInput
            label="Item Name"
            name="name"
            value={formData?.inputData?.name}
            onChange={onInputChange}
            placeholder="Enter Item Name"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={itemNameError}
          />
        </Col>

        <Col md="6" className="mt-3">
          <TextInput
            label="Item Code"
            name="code"
            value={formData?.inputData?.code}
            onChange={onInputChange}
            placeholder="Enter Item Code"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={itemCodeError}
          />
        </Col>
        <Col md="6" className="mt-3">
          <SelectInput
            label="category"
            options={categorySelectOptions}
            value={selectedCategory}
            onSelect={handleCategorySelect}
            placeholder="Select Category"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.category_id}
          />
        </Col>
        <Col md="6" className="mt-3">
          <SelectInput
            label="UOM"
            options={uomSelectOptions}
            value={selectedUom}
            onSelect={handleUomSelect}
            placeholder="Select UOM"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.uom_id}
          />
        </Col>
        {showOemAndGroup && (
          <>
            <Col md="6" className="mt-3">
              <SelectInput
                label="OEM"
                options={OEMSelectOptions}
                value={selectedOEM}
                onSelect={handleOEMSelect}
                placeholder="Select OEM"
                inputClassName="form-control"
                labelClassName="form-label"
                asterisk={true}
                customError={formErrors?.oem_id}
              />
            </Col>
            <Col md="6" className="mt-3">
              <SelectInput
                label="Group"
                options={groupSelectOptions}
                value={selectedGroup}
                onSelect={handleGroupSelect}
                placeholder="Select Group"
                inputClassName="form-control"
                labelClassName="form-label"
                asterisk={true}
                customError={formErrors?.group_id}
              />
            </Col>
          </>
        )}

        <Col md="6" className="mt-3">
          <TextAreaInput
            label="Item Description"
            name="descriptions"
            value={formData?.inputData?.descriptions}
            onChange={onInputChange}
            placeholder="Enter Item Descriptions"
            inputClassName="form-control"
            labelClassName="form-label"
            customError={formErrors?.descriptions}
          />
        </Col>
      </Row>

      <Row className="mt-4">
        <Col lg="12">
          <CheckboxInput
            name="is_active"
            label="Is Active"
            value={formData?.inputData?.is_active}
            checked={formData?.inputData?.is_active}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
          />
        </Col>
      </Row>
      {loadingData && (
        <div style={loaderOverlay}>
          <LoaderCreatePage />
        </div>
      )}
    </CustomForm>
  );
};

export default ItemCreate;
